import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbsUpFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75 15.0417V8.68729C3.75 8.30771 4.05771 8 4.43729 8C4.59624 8 4.73445 8.10901 4.77148 8.26358L5.15998 9.88513C5.17826 9.96144 5.1875 10.0396 5.1875 10.1181V15.5208C5.1875 15.7855 4.97297 16 4.70833 16C4.17906 16 3.75 15.5709 3.75 15.0417Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.084 3.57857L8.64078 7.82763C8.57713 7.93833 8.55824 8.06918 8.58799 8.19336L8.7181 8.73643C8.91922 9.57589 9.02083 10.4361 9.02083 11.2993V15C9.02083 15.5523 9.46855 16 10.0208 16H12.1819C13.4476 16 14.5771 15.2057 15.0052 14.0146L16.3491 10.2749C16.7472 9.16727 15.9263 8 14.7493 8H11.0744C11.0067 8 10.9585 7.93429 10.9793 7.86984C11.462 6.37587 12.0946 4.66529 11.7484 3.57232C11.6476 3.25434 11.2503 3.28941 11.084 3.57857Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75 15.0417V8.68729C3.75 8.30771 4.05771 8 4.43729 8C4.59624 8 4.73445 8.10901 4.77148 8.26358L5.15998 9.88513C5.17826 9.96144 5.1875 10.0396 5.1875 10.1181V15.5208C5.1875 15.7855 4.97297 16 4.70833 16C4.17906 16 3.75 15.5709 3.75 15.0417Z",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.084 3.57857L8.64078 7.82763C8.57713 7.93833 8.55824 8.06918 8.58799 8.19336L8.7181 8.73643C8.91922 9.57589 9.02083 10.4361 9.02083 11.2993V15C9.02083 15.5523 9.46855 16 10.0208 16H12.1819C13.4476 16 14.5771 15.2057 15.0052 14.0146L16.3491 10.2749C16.7472 9.16727 15.9263 8 14.7493 8H11.0744C11.0067 8 10.9585 7.93429 10.9793 7.86984C11.462 6.37587 12.0946 4.66529 11.7484 3.57232C11.6476 3.25434 11.2503 3.28941 11.084 3.57857Z",
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
export default SvgThumbsUpFilled;
